function getSportdogPageTitle(...segments) {
  const sportDogSegment = 'SportDog';

  segments.push(sportDogSegment);

  return segments.join(' - ');
}

module.exports = {
  getSportdogPageTitle,
};
